const POLICY_ALIASES = {
  annual: ['annual', 'yıllık izin', 'yillik izin', 'yillik-izin', 'annual-leave'],
  excuse: ['excuse', 'mazeret izni', 'mazeret', 'mazeret-izni'],
  marriage: ['marriage', 'evlilik izni', 'evlilik', 'nikah izni'],
  bereavement: ['bereavement', 'vefat izni', 'vefat', 'ölüm izni', 'olum izni'],
  relocation: ['relocation', 'taşınma izni', 'tasınma izni', 'tasima izni', 'tasınma', 'taşınma'],
  maternity: ['maternity', 'doğum izni', 'dogum izni', 'doğum', 'dogum']
};

const LEAVE_POLICY_TEXTS = {
  annual: {
    title: 'Yıllık İzin Kuralları',
    summary: [
      'İşe giriş tarihinden itibaren ilk 1 yıl dolana kadar yıllık izin hakkı bulunmaz.',
      '1. yıldan 5. yılın sonuna kadar çalışanlara yıllık 14 gün izin tanımlanır.',
      '5. yıldan 15. yılın sonuna kadar yıllık izin hakkı 20 güne çıkar.',
      '15. yıldan itibaren çalışanların yıllık izin hakkı 27 gündür.'
    ],
    notes: ['Yıllık izin bakiyesi kullanılmadığında bir sonraki yıla devreder.']
  },
  excuse: {
    title: 'Mazeret İzni Kullanımı',
    summary: [
      'Yıllık olarak 3 tam gün (toplam 27 saat) mazeret izni tanımlanır.',
      'Mazeret izinleri saatlik olarak planlanır ve sistem üzerinden saat bazında talep edilir.',
      'Tam günlük izin ihtiyaçlarında mazeret izni kullanılamaz; bu durumlar için farklı izin tipleri seçilmelidir.'
    ]
  },
  marriage: {
    title: 'Evlilik İzni',
    summary: ['Resmi nikâh sonrasında çalışanlara 3 gün süreyle evlilik izni verilir.']
  },
  bereavement: {
    title: 'Vefat İzni',
    summary: ['Birinci derece yakınların vefatı halinde, vefat tarihinden itibaren 3 gün izin verilir.']
  },
  relocation: {
    title: 'Taşınma İzni',
    summary: [
      'Şehir içi taşınmalarda 1 gün taşınma izni kullanabilirsiniz.',
      'Şehirler arası taşınmalarda ise 2 gün taşınma izni tanımlanır.'
    ]
  },
  maternity: {
    title: 'Doğum ve Süt İzinleri',
    summary: [
      'Kadın çalışanlar için doğumdan itibaren 8 hafta (56 gün) doğum izni uygulanır.',
      'Doğum yapan çalışanların eşlerine doğumdan itibaren 5 gün babalık izni tanınır.',
      'Doğum sonrası ilk 1 yıl boyunca kadın çalışanlar günlük 1,5 saatlik süt izni kullanabilir.'
    ],
    notes: ['Süt izni kullanılmadığı veya başka bir izin tipi tercih edildiği durumlarda hak yanar ve devredilemez.']
  }
};

const normalize = (value) => value?.toString().trim().toLocaleLowerCase('tr-TR');

export const findPolicyKey = (leaveType) => {
  if (!leaveType) return null;
  const candidates = [leaveType.code, leaveType.name];
  for (const candidate of candidates) {
    const normalized = normalize(candidate);
    if (!normalized) continue;
    for (const [key, aliases] of Object.entries(POLICY_ALIASES)) {
      if (aliases.includes(normalized)) {
        return key;
      }
    }
  }
  return null;
};

export const getLeavePolicy = (leaveType) => {
  const key = findPolicyKey(leaveType);
  return key ? LEAVE_POLICY_TEXTS[key] : null;
};

export const formatLeaveUnit = (unit) => {
  if (!unit) return '';
  switch (unit) {
    case 'hour':
    case 'hours':
      return 'Saat';
    case 'day':
    case 'days':
      return 'Gün';
    default:
      return unit;
  }
};

export default LEAVE_POLICY_TEXTS;
